var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-preview"},[_c('div',{staticClass:"drag-protect",attrs:{"id":"drag-protect"}}),(_vm.frameSrc)?_c('iframe',{ref:"frame",attrs:{"name":"Opoint_attr","src":_vm.frameSrc,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }